import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import styles from './HeaderPageEquipe.module.css'
import { Store, ChevronDown } from 'lucide-react'

function HeaderPageEquipe({ nomeEstabelecimento, nomePage, perfilPath = '/equipe/perfil' }) {
    const navigate = useNavigate();
    const nomeUsuario = localStorage.getItem("nome_usuario") || "";
    const iniciais = nomeUsuario
        .trim()
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(parte => parte[0].toUpperCase())
        .join('');

    // Atendente que atende mais de um estabelecimento (mesmo email, um
    // registro de Equipe por loja — ver /login) recebe essa lista pronta no
    // login. Só existe quando há mais de uma opção.
    const estabelecimentosDisponiveis = (() => {
        try {
            return JSON.parse(localStorage.getItem('equipe_estabelecimentos') || '[]');
        } catch {
            return [];
        }
    })();
    const temMaisDeUmEstabelecimento = estabelecimentosDisponiveis.length > 1;
    const [trocando, setTrocando] = useState(false);

    const trocarEstabelecimento = async (e) => {
        const novoId = e.target.value;
        if (!novoId || String(novoId) === localStorage.getItem('estabelecimento_id')) return;

        setTrocando(true);
        try {
            const API_URL = process.env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_URL}/equipe/trocar-estabelecimento`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ id_estabelecimento: novoId })
            });

            const data = await response.json();

            if (!response.ok) {
                alert(data.mensagemErro || 'Não foi possível trocar de estabelecimento.');
                setTrocando(false);
                return;
            }

            localStorage.setItem('token', data.token);
            localStorage.setItem('estabelecimento_id', data.id_estabelecimento);
            localStorage.setItem('nomeEstabelecimento', data.nomeEstabelecimento);
            localStorage.setItem('id_funcionario', data.id_funcionario);

            // Recarrega pra garantir que todos os contexts (pedidos, itens, SSE)
            // busquem os dados do estabelecimento novo do zero.
            window.location.reload();
        } catch (error) {
            alert('Erro de conexão ao trocar de estabelecimento.');
            setTrocando(false);
        }
    };

    return (
        <header className={styles.headerPageEquipe}>
            <div className={styles.headerLeft}>
                <div className={styles.secaoIcon}>
                    <Store size={28} className={styles.iconEstabelecimento} />
                </div>
                <div className={styles.secaoInfo}>
                    {temMaisDeUmEstabelecimento ? (
                        <div className={styles.seletorEstabelecimentoWrapper}>
                            <select
                                className={styles.seletorEstabelecimento}
                                value={localStorage.getItem('estabelecimento_id') || ''}
                                onChange={trocarEstabelecimento}
                                disabled={trocando}
                                aria-label="Trocar de estabelecimento"
                            >
                                {estabelecimentosDisponiveis.map(est => (
                                    <option key={est.id_estabelecimento} value={est.id_estabelecimento}>
                                        {est.nomeEstabelecimento}
                                    </option>
                                ))}
                            </select>
                            <ChevronDown size={14} className={styles.seletorIcone} />
                        </div>
                    ) : (
                        <p className={styles.txtNomeEstabelecimento}>{nomeEstabelecimento}</p>
                    )}
                    <p className={styles.txtNomePage}>{nomePage}</p>
                </div>
            </div>
            <button
                type="button"
                className={styles.avatarBadge}
                onClick={() => navigate(perfilPath)}
                aria-label="Meu perfil"
            >
                {iniciais || '?'}
            </button>
        </header>
    )
}

export default HeaderPageEquipe
